var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideoMulticolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-video-multicolor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1168, -583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120, 279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-7",
    transform: "translate(0, 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Video/Multicolor",
    transform: "translate(48, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(0, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.11,14.7485755 L18,11.4452113 L18,4.5584627 L22.11,1.2507232 C22.90875,0.611926952 24,1.26822447 24,2.37955494 L24,13.6197438 C24,14.7354496 22.905,15.3873718 22.11,14.7485755 Z",
    id: "Path",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.0083333 L0,1.99166667 C0,0.89169954 0.89169954,0 1.99166667,0 L14.0083333,0 C14.5365562,0 15.0431444,0.209835707 15.4166543,0.583345661 C15.7901643,0.956855615 16,1.46344382 16,1.99166667 L16,14.0083333 C16,15.1083005 15.1083005,16 14.0083333,16 L1.99166667,16 C1.46344382,16 0.956855615,15.7901643 0.583345661,15.4166543 C0.209835707,15.0431444 0,14.5365562 0,14.0083333 Z",
    id: "Path",
    fill: "#4C69BA"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoMulticolor);
export default __webpack_public_path__ + "static/media/icon-video-multicolor.597b7465.svg";
export { ForwardRef as ReactComponent };